<brightside-web-display-campaign
  [campaign]="campaign"
  [analyticsAttributes]="{ event_name: 'my_spending_info' }"
  (campaignEvent)="handleCampaignEvent($event)"
  [showBackArrow]="true"
></brightside-web-display-campaign>